









import { defineComponent, ref, computed } from '@vue/composition-api'

export default defineComponent({
    props:{
        mbooks:{
            type: Boolean,
            default: false
        },
        text:{
            type: String,
            required: true
        },
        shortChars:{
            type: Number,
            default: 260 //Arbitrary value, ca 3 lines on mobile.
        }
    },
    setup(props) {
        /**
         * Because the content could be an HTML content, we cannot do a substring! We must use a styled truncation.
         */
            const showMoreText = ref<Boolean>(false);
            let canShowMoreText = ref<Boolean>(props.text.length > props.shortChars);
            
        return {
            canShowMoreText,
            showMoreText
        }
    },
})
